import React from 'react';
import AdminApproval from './AdminApproval';
import AdminInvite from './AdminInvite';

const AdminDashboard = () => {
  return (
    <div className="admin-container">
      <h1>Admin Dashboard</h1>
      <div className="admin-sections">
        <div className="admin-box">
          <h2>Approve Users</h2>
          <AdminApproval />
        </div>
        <div className="admin-box">
          <h2>Invite New Users</h2>
          <AdminInvite />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
